import { useState, useRef, useEffect } from "react";
import { TAG_COLORS } from "../constants";

const ALL_TAGS = ["Lecture", "Assignment", "Rubric", "Syllabus", "Feedback", "Research", "Quiz", "Midterm", "Final", "Other"];

export default function TagPicker({ tag, fileId, onUpdate }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const c = TAG_COLORS[tag] || TAG_COLORS.Other;

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <span
        onClick={e => { e.stopPropagation(); setOpen(prev => !prev); }}
        title="Click to change tag"
        style={{ padding: "2px 10px", backgroundColor: c.bg, color: c.color, border: `0.5px solid ${c.border}`, borderRadius: "20px", fontSize: "11px", fontWeight: "500", whiteSpace: "nowrap", cursor: "pointer", userSelect: "none" }}
      >
        {tag}
      </span>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", right: 0, background: "white", border: "0.5px solid #e5e7eb", borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.10)", zIndex: 500, padding: "4px", minWidth: "130px" }}>
          {ALL_TAGS.map(t => {
            const tc = TAG_COLORS[t];
            return (
              <div
                key={t}
                onClick={e => { e.stopPropagation(); onUpdate(fileId, t); setOpen(false); }}
                style={{ padding: "5px 10px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", background: t === tag ? "#f3f4f6" : "transparent" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f3f4f6"}
                onMouseLeave={e => e.currentTarget.style.background = t === tag ? "#f3f4f6" : "transparent"}
              >
                <span style={{ padding: "1px 8px", backgroundColor: tc.bg, color: tc.color, border: `0.5px solid ${tc.border}`, borderRadius: "20px", fontSize: "11px", fontWeight: "500" }}>{t}</span>
                {t === tag && <span style={{ fontSize: "10px", color: "#9ca3af", marginLeft: "auto" }}>✓</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}